import React from 'react';
import MeetingListHighlight from '../../components/misc/MeetingListHighlight.jsx';
import MeetingListItem from '../../components/misc/MeetingListItem.jsx';
import MeetingNotesEdit from '../../components/misc/MeetingNotesEdit.jsx';

const MeetingNotes = ({
    calendarMeetingId,
    calendarMeetingUserNotes,
    calendarMeetingAINotes,
    nothingFound,
    editButtonText,
    highlightText,
    notesType,
    noEdit = false
}) => {
    const renderNotes = () => {
        if (calendarMeetingUserNotes !== null && calendarMeetingUserNotes?.length > 0) {
            return calendarMeetingUserNotes.map((note) => <MeetingListItem key={note.id} text={note.text} />);
        }

        if (calendarMeetingUserNotes === null && calendarMeetingAINotes?.length > 0) {
            return (
                <MeetingListHighlight text={highlightText}>
                    {calendarMeetingAINotes.map((note) => (
                        <MeetingListItem key={note.id} text={note.text} />
                    ))}
                </MeetingListHighlight>
            );
        }

        return <div className='text-theme1-title2'>{nothingFound}</div>;
    };

    const notesToEdit =
        calendarMeetingUserNotes !== null && calendarMeetingUserNotes?.length > 0
            ? calendarMeetingUserNotes
            : calendarMeetingAINotes;

    return (
        <>
            {renderNotes()}
            {!noEdit && (
                <MeetingNotesEdit
                    calendarMeetingId={calendarMeetingId}
                    editButtonText={editButtonText}
                    notes={notesToEdit}
                    notesType={notesType}
                />
            )}
        </>
    );
};

export default MeetingNotes;
